import React from 'react'
import UserGreenIcon from '../../../Common/svg/usergreenicon'
import PhoneIcon from '../../../Common/svg/phoneicon'
import EmailIcon from '../../../Common/svg/emailicon'
import LocationSvg from '../../../Common/svg/locationGray'
import ClockIcon from '../../../Common/svg/reports/clockicon'
import { Clock } from 'react-feather'

const UserInfo = ({user ,delivery}) => {
  return (
  <div className="col-md-4 pe-0">
          <div className="card rounded-4 shadow-sm">
            <div className="card-body">
              <div className="d-flex align-items-center gap-2   mb-3">
                <UserGreenIcon />
                <h5 className="text-smoke font16 font700">معلومات العميل</h5>
              </div>

              <ul className="d-flex flex-column gap-2   mt-2">
                <div>
                  <h6 className="text-gray">الإسم</h6>
                  <h6 className='text-smoke'> {user?.name} </h6>
                </div>
                <li className="d-flex align-items-center gap-1 ">
                  <PhoneIcon /> <span className='text-smoke'>{user?.phone}</span>
                </li>
                {/* <li className="d-flex align-items-center gap-1 ">
                  <EmailIcon /> <span>{user?.email}</span>{" "}
                </li> */}
                بيانات التسليم :
                <li className="d-flex align-items-center gap-1 ">
                  <LocationSvg /> <span className='text-smoke'> {delivery?.address?.name} - {delivery?.address?.phone}</span>
                </li>
                  <li className="d-flex align-items-center gap-1 ">
                  <LocationSvg /> <span className='text-smoke'> {delivery?.address?.full_address} </span>
                </li>
                     <li className="d-flex align-items-center gap-1 ">
                الوقت المقدر للتسليم :<span className='text-smoke'> {delivery?.estimated_delivery_time} </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
  )
}

export default UserInfo